"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnreadCount = exports.useNotificationsStore = exports.resetNotificationsLocally = exports.markAllReadLocally = exports.restoreLocally = exports.archiveLocally = exports.markUnreadLocally = exports.markReadLocally = exports.selectNotification = exports.getSelectedNotification = exports.getUnreadCount = exports.getHasMore = exports.getLoadingMore = exports.getPagination = exports.getNotifications = exports.getUserId = exports.isNotificationsInitialised = exports.setLoadingMore = exports.replaceNotifications = exports.appendNotifications = exports.initUnreadCount = exports.initNotifications = exports.getNotificationsSnapshot = exports.subscribe = void 0;
var react_1 = require("react");
var state = {
    initialised: false,
    userId: null,
    unreadCount: 0,
    notifications: [],
    pagination: { page: 1, per_page: 20, total: 0, total_pages: 0 },
    loadingMore: false,
    filter: 'unread',
    q: '',
    selectedId: null,
};
var listeners = new Set();
var emit = function () {
    listeners.forEach(function (l) { return l(); });
};
var setState = function (patch) {
    state = __assign(__assign({}, state), patch);
    emit();
};
var subscribe = function (listener) {
    listeners.add(listener);
    return function () { return listeners.delete(listener); };
};
exports.subscribe = subscribe;
var getNotificationsSnapshot = function () { return state; };
exports.getNotificationsSnapshot = getNotificationsSnapshot;
/**
 * Bootstrapping (server-injected JSON)
 */
var initNotifications = function (payload) {
    var _a, _b;
    if (state.initialised)
        return;
    setState({
        initialised: true,
        userId: payload.userId,
        unreadCount: payload.unreadCount,
        notifications: (_a = payload.notifications) !== null && _a !== void 0 ? _a : [],
        pagination: (_b = payload.pagination) !== null && _b !== void 0 ? _b : state.pagination,
    });
};
exports.initNotifications = initNotifications;
/**
 * Bootstrapping for non-inbox pages (eg preferences page)
 * - Allows sidebar badge render without fetching inbox.
 */
var initUnreadCount = function (args) {
    setState({
        userId: args.userId,
        unreadCount: args.unreadCount,
    });
};
exports.initUnreadCount = initUnreadCount;
var appendNotifications = function (items, pagination) {
    setState({ notifications: __spreadArray(__spreadArray([], state.notifications, true), items, true), pagination: pagination });
};
exports.appendNotifications = appendNotifications;
var replaceNotifications = function (items, pagination) {
    setState({ notifications: items, pagination: pagination });
};
exports.replaceNotifications = replaceNotifications;
var setLoadingMore = function (loading) {
    setState({ loadingMore: loading });
};
exports.setLoadingMore = setLoadingMore;
var isNotificationsInitialised = function () { return state.initialised; };
exports.isNotificationsInitialised = isNotificationsInitialised;
var getUserId = function () { return state.userId; };
exports.getUserId = getUserId;
var getNotifications = function () { return state.notifications; };
exports.getNotifications = getNotifications;
var getPagination = function () { return state.pagination; };
exports.getPagination = getPagination;
var getLoadingMore = function () { return state.loadingMore; };
exports.getLoadingMore = getLoadingMore;
var getHasMore = function () { return state.pagination.page < state.pagination.total_pages; };
exports.getHasMore = getHasMore;
var getUnreadCount = function () {
    if (typeof state.unreadCount === 'number')
        return state.unreadCount;
    return state.notifications.filter(function (n) { return !n.read_at && !n.archived_at; }).length;
};
exports.getUnreadCount = getUnreadCount;
var getSelectedNotification = function () {
    var _a;
    if (!state.selectedId)
        return null;
    return (_a = state.notifications.find(function (n) { return n.id === state.selectedId; })) !== null && _a !== void 0 ? _a : null;
};
exports.getSelectedNotification = getSelectedNotification;
var selectNotification = function (id) {
    setState({ selectedId: id });
};
exports.selectNotification = selectNotification;
var markReadLocally = function (id) {
    var now = new Date().toISOString();
    var before = state.notifications.find(function (n) { return n.id === id; });
    var wasUnread = before && !before.read_at && !before.archived_at;
    var next = state.notifications.map(function (n) { return (n.id === id ? __assign(__assign({}, n), { read_at: now }) : n); });
    setState({
        notifications: next,
        unreadCount: wasUnread ? Math.max(0, state.unreadCount - 1) : state.unreadCount,
    });
};
exports.markReadLocally = markReadLocally;
var markUnreadLocally = function (id) {
    var before = state.notifications.find(function (n) { return n.id === id; });
    var wasUnread = before && !before.read_at && !before.archived_at;
    var next = state.notifications.map(function (n) { return (n.id === id ? __assign(__assign({}, n), { read_at: null }) : n); });
    setState({
        notifications: next,
        unreadCount: wasUnread ? state.unreadCount : state.unreadCount + 1,
    });
};
exports.markUnreadLocally = markUnreadLocally;
var archiveLocally = function (id) {
    var now = new Date().toISOString();
    var before = state.notifications.find(function (n) { return n.id === id; });
    var wasUnread = before && !before.read_at && !before.archived_at;
    var next = state.notifications.map(function (n) { return (n.id === id ? __assign(__assign({}, n), { archived_at: now }) : n); });
    setState({
        notifications: next,
        unreadCount: wasUnread ? Math.max(0, state.unreadCount - 1) : state.unreadCount,
    });
};
exports.archiveLocally = archiveLocally;
var restoreLocally = function (id) {
    var next = state.notifications.map(function (n) { return (n.id === id ? __assign(__assign({}, n), { archived_at: null }) : n); });
    setState({ notifications: next });
};
exports.restoreLocally = restoreLocally;
var markAllReadLocally = function () {
    var now = new Date().toISOString();
    var next = state.notifications.map(function (n) {
        return !n.archived_at && !n.read_at ? __assign(__assign({}, n), { read_at: now }) : n;
    });
    setState({
        notifications: next,
        unreadCount: 0,
    });
};
exports.markAllReadLocally = markAllReadLocally;
var resetNotificationsLocally = function () {
    state = {
        initialised: false,
        userId: null,
        unreadCount: 0,
        notifications: [],
        pagination: { page: 1, per_page: 20, total: 0, total_pages: 0 },
        loadingMore: false,
        filter: 'unread',
        q: '',
        selectedId: null,
    };
    emit();
};
exports.resetNotificationsLocally = resetNotificationsLocally;
var useNotificationsStore = function () {
    return (0, react_1.useSyncExternalStore)(exports.subscribe, exports.getNotificationsSnapshot, exports.getNotificationsSnapshot);
};
exports.useNotificationsStore = useNotificationsStore;
var useUnreadCount = function () {
    return (0, react_1.useSyncExternalStore)(exports.subscribe, exports.getUnreadCount, exports.getUnreadCount);
};
exports.useUnreadCount = useUnreadCount;
